angular.module('am4').factory('forgotPassword', function($http, apiUrl) {
    return {
        request: function(email) {
            return $http.post(apiUrl + '/auth/forgot/request', {
                email: email
            })
            .then(function(res) {
                return res.data;
            });
        },
        reset: function(token, password) {
            return $http.post(apiUrl + '/auth/forgot/reset', {
                token: token,
                password: password
            })
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/forgotPassword.js